import React, { Component } from 'react';
import moment from 'moment';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { FormGroup, ControlLabel, FormControl, Col } from 'react-bootstrap';
import firebase from '../helpers/firebase';
import Loader from 'halogen/RingLoader'
import BalanceTable from './BalanceTable.js';
import TimeOffTables from './TimeOffTables.js';
import AbsenceTables from './AbsenceTables.js';
import { formatNumber } from '../helpers/utils';
import { TABLE_NAME, EMPLOYMENT, COUNTRY } from '../helpers/constants';
import { connect } from 'react-redux'

const db = firebase.database();

const defaultCountry = COUNTRY.TW.code;
const defaultEmployment = EMPLOYMENT.FT.type;

class Admin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userId: this.props.match.params.id,
      pastTimeOffs: [],
      upcomingTimeOffs: [],
      balances: null,
      fullBalances: null,
      balanceDate: moment().format('YYYY-MM-DD')
    }

    const { user } = this.props;

    if (!(user.level && user.level === 'admin')) {
      window.location.href = '/dashboard';
      return true;
    }

    let selectedUser;
    db.ref(`${TABLE_NAME.USERS}/${this.state.userId}`).once('value').then((snapshot) => {
      selectedUser = Object.assign({id: snapshot.key}, snapshot.val())
      if (!selectedUser.country) {
        this.onFieldChange(TABLE_NAME.USERS, user.id, {
          'country': defaultCountry
        });
        selectedUser.country = defaultCountry;
      }
      this.setState({
        user: selectedUser
      });
    });

    this.onFieldChange = this.onFieldChange.bind(this);
    this.handleBalanceChange = this.handleBalanceChange.bind(this);
  }

  onFieldChange(ref, child, updates) {
    db.ref(ref).child(child).update(updates).then(() => {
      if (updates.employment) {
        db.ref('balances').child(child).once('value').then(snapshot => {
          const fullBalances = snapshot.val();
          this.setState({fullBalances});
          console.log('finish fetching new balance');
        });
      }
    });
  }

  handleBalanceChange(balances, fullBalances) {
    this.setState({balances, fullBalances});
  }

  render() {
    const {user, balances, fullBalances, balanceDate} = this.state;
    if (!user) {
      return (
        <Loader color="#26194b" size="120px" className="loader" />
      )
    }
    return <div>
      <h1>Details for {user.name}</h1>

      <h3>General Info</h3>
      <FormGroup>
        <ControlLabel>Name</ControlLabel>
        <FormControl
          type='text'
          value={user.name}
          onChange={(e) => {
            this.setState({
              user: Object.assign({}, user, {name: e.target.value})
            });
            this.onFieldChange(TABLE_NAME.USERS, user.id, {
              name: e.target.value,
            })
          }}
          style={{
            width: 170
          }}
        />
      </FormGroup>
      <FormGroup>
        <ControlLabel>Start Date</ControlLabel>
        <div>
          <DayPickerInput
            value={user.startDate || '2017-01-01'}
            onDayChange={(date) => this.onFieldChange(TABLE_NAME.USERS, user.id, {
              'startDate': date.format('YYYY-MM-DD')
            })}
            className='form-control'
            style={{
              width: 170
            }}
            name="startDate"
            id="startDate"
            format="YYYY-MM-DD"
          />
        </div>
      </FormGroup>
      <FormGroup>
        <ControlLabel>Employment</ControlLabel>
        <div>
          <FormControl id="employment"
            name="employment"
            onChange={(e) => {
              this.setState({
                user: Object.assign({}, user, {'employment': e.target.value})
              });
              this.onFieldChange(TABLE_NAME.USERS, user.id, {
                'employment': e.target.value
              });
            }}
            style={{
              width: 170
            }}
            componentClass="select"
            placeholder="select"
            value={user.employment || defaultEmployment}>
            {
              Object.keys(EMPLOYMENT).map(key => {
                return <option value={EMPLOYMENT[key].type}>{EMPLOYMENT[key].fullForm}</option>
              })
            }
          </FormControl>
        </div>
      </FormGroup>
      <FormGroup>
        <ControlLabel>Country</ControlLabel>
        <div>
          <FormControl id="country"
            name="country"
            onChange={(e) => {
              this.setState({
                user: Object.assign({}, user, {'country': e.target.value})
              });
              this.onFieldChange(TABLE_NAME.USERS, user.id, {
                'country': e.target.value
              });
            }}
            style={{
              width: 170
            }}
            componentClass="select"
            placeholder="select"
            value={user.country || defaultCountry}>
            {
              Object.keys(COUNTRY).map(key => {
                return <option value={COUNTRY[key].code}>{COUNTRY[key].name}</option>
              })
            }
          </FormControl>
        </div>
      </FormGroup>

      <hr />

      <h3>Current Balances</h3>
      <div>
        Balances as of <DayPickerInput
          value={balanceDate}
          onDayChange={(date) => this.setState({
            balanceDate: date.format('YYYY-MM-DD')
          })}
          className='form-control'
          style={{
            width: 170
          }}
          name="balanceDate"
          id="balanceDate"
          format="YYYY-MM-DD"
          dayPickerProps={{
            todayButton: 'Go to Today',
            enableOutsideDays: true,
            modifiers: {
              monday: { daysOfWeek: [1] },
            },
            disabledDays: {
              before: new Date(),
              after: moment().endOf('year').toDate(),
            }
          }}
        />
      </div>
      <BalanceTable
        onBalanceChange={this.handleBalanceChange}
        startDate={balanceDate}
        userId={user.id}
      />

      <h3>Manual Edits to Balances</h3>
      <FormGroup>
        <ControlLabel>Carried Over PTO From Last Year</ControlLabel>
        {balances && <FormControl
          type='number'
          value={balances.pto.carriedOver}
          onChange={(e) => {
            const prevValue = balances.pto.carriedOver;
            const newValue = Number(e.target.value);
            const newBalances = Object.assign({}, balances);
            newBalances.pto.carriedOver = formatNumber(newValue);
            newBalances.pto.balance = formatNumber(balances.pto.balance - prevValue + newValue);
            this.onFieldChange(TABLE_NAME.BALANCES, `${user.id}/current/pto`, newBalances.pto)
            this.setState({
              balances: newBalances
            });
          }}
          style={{
            width: 170
          }}
        />}
      </FormGroup>
      <FormGroup>
        <ControlLabel>Annual PTO</ControlLabel>
        {balances && <FormControl
          type='number'
          value={fullBalances.rules.pto.annualAmount}
          onChange={(e) => {
            const newValue = formatNumber(e.target.value);
            const newFullBalances = Object.assign({}, fullBalances);
            newFullBalances.rules.pto.annualAmount = newValue;
            this.onFieldChange(TABLE_NAME.BALANCES, `${user.id}/rules/pto`, {
              annualAmount: newValue
            });
            this.setState({
              fullBalances: newFullBalances
            });
          }}
          style={{
            width: 170
          }}
        />}
      </FormGroup>

      <hr />
      <TimeOffTables
        admin
        userId={user.id}
      />
      <Col xs={12} md={6}>
        <AbsenceTables
          admin
          userId={user.id}
        />
      </Col>
    </div>;
  }
}

const mapStateToProps = (state) => {
  const { user } = state.auth;
  return { user };
}

export default connect(mapStateToProps)(Admin);



// WEBPACK FOOTER //
// ./src/components/UserDetails.js